import CryptoJS from "crypto-js";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useTravelChangePlanFlow, {
  TRAVEL_CHANGE_PLAN_FLOW,
} from "../../../../hooks/useTravelChangePlanFlow";
import {
  TRAVEL_CHANGE_PLAN_REVIEW_AND_CONFIRM,
  TRAVEL_CHANGE_PLAN_SELECT_NEW_PLAN,
} from "./data";
import ReviewAndConfirmTravelPage from "./reviewAndConfirmTravelPage";
import SelectNewTravelPlan from "./selectNewTravelPlan";

const ChangePlanTravel = () => {
  const navigate = useNavigate();
  const { policy_id } = useParams();
  const { currentStep, handleFlowChange } = useTravelChangePlanFlow();

  // Decode policy number from URL
  const policyNumber = decodeURIComponent(policy_id);

  const handleNavigationToPolicyOverview = () => {
    // We need to recreate the encrypted policy ID to navigate back
    const secretKey = "i-hate-meej";
    const encryptedValue = CryptoJS.AES.encrypt(
      policyNumber,
      secretKey
    ).toString();

    // Convert to URL-safe format (same as policy card)
    const urlSafeEncryptedValue = encryptedValue
      .split("+")
      .join("-") // Replace '+' with '-'
      .split("/")
      .join("_") // Replace '/' with '_'
      .split("=")
      .join(""); // Remove '=' padding

    navigate(
      `/travel-insurance/policy-overview/${urlSafeEncryptedValue}?tabType=ManagePolicy`
    );
  };

  useEffect(() => {
    handleFlowChange(TRAVEL_CHANGE_PLAN_FLOW, 0, 0);
  }, []);

  const PageRenderer = () => {
    switch (currentStep?.name) {
      case TRAVEL_CHANGE_PLAN_SELECT_NEW_PLAN:
        return (
          <SelectNewTravelPlan
            handleNavigationToPolicyOverview={handleNavigationToPolicyOverview}
          />
        );
      case TRAVEL_CHANGE_PLAN_REVIEW_AND_CONFIRM:
        return (
          <ReviewAndConfirmTravelPage
            handleNavigationToPolicyOverview={handleNavigationToPolicyOverview}
          />
        );

      default:
        return (
          <SelectNewTravelPlan
            handleNavigationToPolicyOverview={handleNavigationToPolicyOverview}
          />
        );
    }
  };

  return (
    <div className="mainCarDetailsModal pt-[22px] rtl:max767:pt-0 pb-[5%] max767:w-full max767:overflow-y-scroll max767:pb-[5%] max767:h-screen ipad:pt-[10%] ipad:h-[93vh] ipad:overflow-y-scroll max767:pt-0">
      <AnimatePresence mode="popLayout" initial={false}>
        <motion.div
          key={currentStep?.name || "step"}
          initial={{ opacity: 0, x: 12 }}
          animate={{ opacity: 1, x: 0 }}
          exit={{ opacity: 0, x: -12 }}
          transition={{ duration: 0.22, ease: "easeOut" }}
        >
          {PageRenderer()}
        </motion.div>
      </AnimatePresence>
      <div id="travel-footer-portal" />
      <div id="home-footer-portal" />
    </div>
  );
};

export default ChangePlanTravel;
